import { Component, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.scss']
})
export class ChatBotComponent {

  @ViewChild('chatBox') chatBox!: ElementRef;

  chatStarted = false;
  showUpload = false;

  userMessage = '';
  chats: any[] = [];

  selectedAction = '';
  selectedMonth = '';
  selectedYear = '';
  uploadedFilePath = '';

  // ✅ START CHAT FROM BUTTON
  async startChat(action: string) {
    this.chatStarted = true;
    this.selectedAction = action;

    this.pushBot(`You selected: ${action}`);
    this.askMonthYear();
  }

  // ✅ ASK MONTH / YEAR
  askMonthYear() {
    this.pushBot('Please enter Month and Year (e.g. March 2025)');
  }

  // ✅ SEND MESSAGE
  async sendMessage() {
    if (!this.userMessage.trim()) return;

    this.pushUser(this.userMessage);

    // Step 1 → User entered month/year
    if (!this.selectedMonth) {
      const parts = this.userMessage.split(' ');
      this.selectedMonth = parts[0];
      this.selectedYear = parts[1];

      this.pushBot('Please upload your file now.');
      this.showUpload = true;

      this.userMessage = '';
      return;
    }

    // Normal Gemini Chat
    const reply = await this.callGemini(
      this.getBusinessPrompt(),
      this.userMessage
    );

    this.pushBot(reply);
    this.userMessage = '';
  }

  // ✅ FILE UPLOAD HANDLER
  async handleFileUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.pushUser(`Uploaded file: ${file.name}`);

    const path = await this.uploadfile(file);
    this.uploadedFilePath = path;

    this.pushBot(`File uploaded successfully.`);

    // ✅ Call Gemini to detect which function to call
    const detection = await this.callGemini(
      `Detect the correct backend function to call from: submitRatebook, verifyRatebook, createEvent.`,
      `User selected ${this.selectedAction} and uploaded ${path}`
    );

    this.pushBot(detection);

    // ✅ Call actual function based on Gemini response
    if (detection.includes('submitRatebook')) {
      this.submitRatebook(path);
    }

    if (detection.includes('verifyRatebook')) {
      this.verifyRatebook(path);
    }
  }

  // ✅ UI HELPERS
  pushUser(text: string) {
    this.chats.push({ type: 'user', text });
    this.scrollDown();
  }

  pushBot(text: string) {
    this.chats.push({ type: 'bot', text });
    this.scrollDown();
  }

  scrollDown() {
    setTimeout(() => {
      this.chatBox?.nativeElement.scrollTo({
        top: this.chatBox.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
    }, 100);
  }

  // ✅ GEMINI CALL
  async callGemini(businessPrompt: string, query: string): Promise<string> {
    // Your existing async function will go here
    return await this.callgeminy(businessPrompt, query);
  }

  // ✅ BUSINESS PROMPT BUILDER
  getBusinessPrompt() {
    return `
You are an enterprise assistant.
Available functions:
1. submitRatebook(filePath)
2. verifyRatebook(filePath)
3. createEvent(filePath)
Return only function name if action required.
    `;
  }

  // ✅ BACKEND FUNCTION CALLS
  async uploadfile(file: File): Promise<string> {
    // API call
    return 'uploads/ratebook_march_2025.xlsx';
  }

  submitRatebook(path: string) {
    this.pushBot(`Ratebook submitted successfully.`);
  }

  verifyRatebook(path: string) {
    this.pushBot(`Ratebook verification started.`);
  }

  // ✅ PLACEHOLDER
  async callgeminy(prompt: string, query: string) {
    return 'submitRatebook';
  }
}
